import React from 'react';

class TimeHolderComponent extends React.PureComponent
{
	render(){
		return(
			<span title={this.props.title}
		      onClick={this.props.onClick}
		      className="time_holder clickable">
                <span className="time" >{this.props.time}</span>
            </span>
		)
	}
}

export {TimeHolderComponent};